<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cZ3Rvy/image/Cover.jpg?1718046516751" alt="This image is the cover for the book Little T has Covid 19"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little T has Covid 19
      </h1>
      <p class="bookDescription body article font2">
        <p>Continuing in the ‘Little T – Tales of a Jamaican Boy’ stories, Little T contracts the Covid 19 sickness and becomes very ill. With the help of a kind nurse and the tender care of his mother, Little T overcomes the illness and is back to his famous singing.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yvonne Morgan-McKenzie
      </h2>
      
      <p class="authorDescription body article">The daughter of the Reverend G. A. and Olga Adassa Morgan, Yvonne was born in St. Thomas, Jamaica. As a child she attended the Aeolus Valley All Age School and later Donald Quarrie Secondary School. She continued her education and also did Home Health which is her current occupation. She travelled to Panama, the Cayman Islands, Haiti, Curacao, and the United States looking for a better life. She enjoys babysitting, reading, writing, cooking, and going for nature walks.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a34bb6d